import { render, staticRenderFns } from "./BankAccountAdd.vue?vue&type=template&id=9bdd94d4&scoped=true"
import script from "./BankAccountAdd.vue?vue&type=script&lang=js"
export * from "./BankAccountAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdd94d4",
  null
  
)

export default component.exports